<template>
  <div class="loader-stub flex-container">
    <slot>
      <span
        v-loading="true"
        :style="{ height, 'max-width': maxWidth }"
        class="loader"/>
    </slot>
  </div>
</template>

<script setup lang="ts">
const {
  height = '200px',
  maxWidth = '400px',
} = defineProps<{
  height?: string | number;
  maxWidth?: string;
}>();
</script>

<style lang="scss">
.loader-stub {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.loader {
  display: block;
  width: 100%;
  margin: 0 0 0 -21px;
}
</style>
